import { GetStaticPaths, GetStaticProps } from 'next'
import React from 'react'

import BlogPage, { BlogPageProps } from '../components/pages/BlogPage'
import { getBlogPostData, getBlogPostPaths } from '../utils/blogUtils'

export default function PostPage(props: BlogPageProps) {
  return <BlogPage {...props} />
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = await getBlogPostPaths()

  return {
    paths,
    fallback: false,
  }
}

export const getStaticProps: GetStaticProps<BlogPageProps> = async ({ params }) => {
  const slugArr = (params?.slug as string[]) || []
  const slug = slugArr.join('/')

  try {
    const blogPostData = await getBlogPostData(slug)
    return {
      props: blogPostData,
      // rebuild this page in the background at most once per minute
      revalidate: 60 * 60,
    }
  } catch (err) {
    return { notFound: true }
  }
}
